// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import { IJSONSchema } from '@glittr/frontend-core/src/plugins/validation/IJSONSchema';
import ResourceLinkSchema from './resource-link-schema';

const schema = {
  $id: '/create-category-request-schema',
  type: 'object',
  required: ['id', 'creatorId', 'translatedLanguage_ISO2'],
  properties: {
    id: {
      type: 'integer',
    },
    links: {
      type: 'array',
      nullable: true,
      items: { ...ResourceLinkSchema },
    },
    creatorId: {
      type: 'integer',
    },
    creatorName: {
      type: 'string',
      nullable: true,
    },
    created: {
      type: 'string',
      format: 'date-time',
    },
    modifierId: {
      type: 'integer',
      nullable: true,
    },
    modifierName: {
      type: 'string',
      nullable: true,
    },
    modified: {
      type: 'string',
      format: 'date-time',
      nullable: true,
    },
    parentCategoryId: {
      type: 'integer',
      nullable: true,
    },
    caption: {
      type: 'string',
      nullable: true,
    },
    sort: {
      type: 'integer',
      nullable: true,
    },
    translatedLanguage_ISO2: {
      type: 'string',
      minLength: 1,
    },
  },
} as IJSONSchema;

export default schema;
